var _Path, _Path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgTimer = function SvgTimer(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.56 1.707a1 1 0 0 1 1.414 1.414L2.088 5.007A1 1 0 1 1 .674 3.593l1.885-1.886Zm14.88 0a1 1 0 1 0-1.414 1.414l1.886 1.886a1 1 0 1 0 1.414-1.414L17.44 1.707Z",
    fill: "currentColor"
  })), _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.733 0a1 1 0 0 0 0 2h1.333a9 9 0 1 0 0 18 9 9 0 0 0 0-18H11.4a1 1 0 1 0 0-2H8.733Zm1.333 4a7 7 0 1 0 0 14 7 7 0 0 0 0-14Zm0 1.667a1 1 0 0 1 1 1v3.55l2.664 2.369a1 1 0 1 1-1.328 1.495l-3.336-2.965v-4.45a1 1 0 0 1 1-1Z",
    fill: "currentColor"
  })));
};
export default SvgTimer;